var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXThin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 10,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.238 8.575a.47.47 0 0 1-.663.663L4.688 5.35.8 9.238a.469.469 0 1 1-.664-.663l3.888-3.887L.137.8A.469.469 0 1 1 .801.137l3.887 3.888L8.575.137a.469.469 0 0 1 .663.664L5.35 4.688z"
})));
export default SvgXThin;